import React from 'react';

import { Markdown } from '~/components';
import { Inner } from '~/styles';

import markdown from './Documents/SweepProgramDepositPlacementCustodialAgreements.md';

export const PageSweepProgramDepositPlacementCustodialAgreements: React.FC = () => {
  return (
    <>
      <Inner pt={0}>
        <Markdown markdown={markdown} />
      </Inner>
    </>
  );
};
